/** @jsxImportSource @emotion/react */
"use client";
import type { Interpolation } from "@emotion/react";
import type { ForYouPostPrayer } from "@packages/sdk";
import {
  cssMediaQueryMinWidthTablet,
  numericPercentages,
  RecommendationDeeplink,
  spacing,
} from "@packages/ui";
import type { MouseEventHandler } from "react";

const containerStyle: Interpolation = {
  display: "flex",
  flexDirection: "column",
  rowGap: spacing.s,
  width: spacing.full,
  [cssMediaQueryMinWidthTablet]: { width: numericPercentages[90] },
};

export const PostPrayerRecommendationButton = ({
  step,
  onClick,
}: {
  step: ForYouPostPrayer;
  onClick?: MouseEventHandler<any>;
}) => (
  <div css={containerStyle}>
    {step.recommendations.map((rec, idx) => (
      <RecommendationDeeplink
        key={`rec.${rec.id}.${idx}`}
        {...rec}
        onClick={onClick}
      />
    ))}
  </div>
);
